import React from 'react'
import { useTranslation } from 'react-i18next'
import { RadioGroup, Radio, FormControlLabel, Typography } from '@mui/material'
import Select from 'packages/ui/FilterSelectMulti'
import TextField from 'components/global/CUK/TextField'

const Status = ({statuses, values, onChange}) => {
  const { t } = useTranslation()
  const choices = [
    {
      label: t('voip.sip.status_up'),
      value: 'up',
      count: statuses?.up || 0,
      id: 1,
    },
    {
      label: t('voip.sip.status_down'),
      value: 'down',
      count: statuses?.down || 0,
      id: 2,
    }
  ]

  return (
    <Select
      options={choices}
      onChange={onChange}
      values={values}
      placeholder={t('voip.sip.status')}
    />
  )
}

export const Preferences = ({preferences, values, onChange}) => {
  const { t } = useTranslation()
  const choices = [
    {
      label: t('voip.sip.calling_profile.default'),
      value: 'default',
      count: preferences.default || 0,
      id: 1,
    },
    {
      label: t('voip.sip.calling_profile.internal'),
      value: 'internal',
      count: preferences.internal || 0,
      id: 2,
    },
    {
      label: t('voip.sip.calling_profile.national'),
      value: 'national',
      count: preferences.national || 0,
      id: 3,
    },
    {
      label: t('voip.sip.calling_profile.national_full'),
      value: 'national_full',
      count: preferences.national_full || 0,
      id: 4,
    },
    {
      label: t('voip.sip.calling_profile.international'),
      value: 'international',
      count: preferences.international || 0,
      id: 5,
    }
  ]

  return (
    <Select
      // @ts-expect-error not tsx
      width={270}
      options={choices}
      onChange={onChange}
      values={values}
      placeholder={t('voip.sip.calling_profile_label')}
    />
  )
}

export const Type = ({loading, value, onChange, types}) => {
  const { t } = useTranslation()
  return (
    <RadioGroup
      row
      value={value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value)
      }}
      sx={{
        gap: 3,
        zIndex: 2,
        '& .MuiRadio-root': {
          padding: '4px',
          '& .MuiSvgIcon-root': {
            fontSize: '16px'
          }
        }
      }}
    >
      <FormControlLabel
        value="room"
        control={<Radio />}
        label={
          <Typography sx={{ fontSize: '12px' }}>
            {
              loading
                ? t('voip.sip.room_filter_loading')
                : t('voip.sip.room_filter', {count: types.room})
            }
          </Typography>
        }
      />
      <FormControlLabel
        value="administrative"
        control={<Radio />}
        label={
          <Typography sx={{ fontSize: '12px' }}>
            {
              loading
                ? t('voip.sip.administrative_filter_loading')
                : t('voip.sip.administrative_filter', {count: types.administrative})
            }
          </Typography>
        }
      />
    </RadioGroup>
  )
}

export const Verbatim = ({value, onChange}) => {
  const {t} = useTranslation()
  return (
    <TextField
      width={'100%'}
      value={value}
      setvalue={newValue => {
        onChange(newValue)
      }}
      type="text"
      input={{
        placeholder: t('voip.sip.search_placeholder'),
        starticon: <i className={'fa-light fa-search'} />
      }}
    />
  )
}


export default Status